/* ShonenSports — moteur d'aperçu : la photo produit RECALCULÉE en direct (06/10/2026). Partagé par le configurateur « Crée ton maillot »
   (ss-configurateur.js) et l'aperçu du nom/numéro des pages produit classiques (ss-apercu-produit.js).
   Cartes tirées de la scène Blender de production sur le PC (scene-pc/POUR-MAC-configurateur, validées contre de vrais rendus, écart < 1,5/255).
   1. On compose le design dans les coordonnées du gabarit d'impression (3000 × 1375 = 12000 × 5500 / 4) :
      gabarit du coloris (motif seul, ou design d'origine sans nom/numéro pour les pages produit) → logos (masques teintés dans la couleur
      des logos du coloris, + contour si le modèle en a un) → nom/numéro dans la police du modèle ou celle choisie.
   2. WebGL2 : passe 1 = albédo moyen, passe 2 = photo (reflets + lumière × design + rebonds, puis table couleur Filmic), une fois par vue.
   Usage : const M = SSMoteur({ assets, prefixe, catalogue, faces }) ; await M.charge ; await M.rendre(etat, { devant: [canvas], dos: [canvas] }).
   etat = { coloris, gabarit: 'motif' | 'produit', poitrine_gauche…haut_dos (id de logo ou null), nom, numero, police_nom, police_num }. */
(function () {
  if (window.SSMoteur) return;
  const TAILLE = 1024, GW = 3000, GH = 1375, KG = GW / 12000, K_EXPORT = 900 / 3510;   // cartes 1024 ↔ gabarit 3000 ; échelle des logos exportés
  const SLOTS = ['poitrine_gauche', 'poitrine_droite', 'centre', 'bas_devant', 'haut_dos', 'bas_dos'];
  const COTE = { poitrine_gauche: 'devant', poitrine_droite: 'devant', centre: 'devant', bas_devant: 'devant', haut_dos: 'dos', bas_dos: 'dos' };
  const rgb = c => `rgb(${c[0]},${c[1]},${c[2]})`;

  window.SSMoteur = function (opts) {
    const BASE = opts.assets || 'assets/', PREFIXE = opts.prefixe || '', FACES = opts.faces || ['devant', 'dos'];
    const url = p => /^(https?:)?\/\//.test(p) || p.startsWith('/') ? p : BASE + (PREFIXE ? PREFIXE + p.replace(/\//g, '-') : p);   // motifs : Fichiers Shopify (URL absolue)
    let CAT = null, P = null; const IMG = {}, POLICES = {}, LOGO = {};
    const charge = (typeof opts.catalogue === 'string' ? fetch(opts.catalogue).then(r => r.json()) : Promise.resolve(opts.catalogue)).then(c => {
      CAT = c; Object.values(CAT.logos2 || {}).forEach(l => l.forEach(x => (LOGO[x.id] = x))); return CAT; });
    const modele = e => CAT.coloris[e.coloris].modele;
    function style(e) {                                       // couleurs du coloris + police et place du nom/numéro du modèle
      const c = CAT.coloris[e.coloris], t = CAT.textes[c.modele] || {};
      return { couleur_logos: c.couleur_logos || [240, 240, 240], couleur_cerne: c.couleur_cerne || [20, 20, 20], cerne: t.cerne ? t.cerne * K_EXPORT : 0,
        nom: t.nom, numero: t.numero, minuscules: t.minuscules, max_lettres: t.max_lettres || 10, fond: c.couleur_fond || [60, 60, 60] };
    }
    const charger = src => IMG[src] || (IMG[src] = new Promise((ok, ko) => { const i = new Image(); i.decoding = 'async'; i.onload = () => ok(i); i.onerror = ko; i.src = url(src); }));
    function police(chemin) {
      if (POLICES[chemin]) return POLICES[chemin];
      const nom = 'ss-' + chemin.replace(/[^a-z0-9]/gi, '');
      POLICES[chemin] = new FontFace(nom, `url(${url(chemin)})`).load().then(ff => { document.fonts.add(ff); return nom; }).catch(() => 'sans-serif');
      return POLICES[chemin];
    }

    /* ---------- 1. design dans les coordonnées du gabarit ---------- */
    const G = document.createElement('canvas'); G.width = GW; G.height = GH;
    const gx = G.getContext('2d', { willReadFrequently: true });
    function boite(cote, [fx, fy, fw, fh]) {                 // fractions du panneau canonique → pixels du gabarit 3000
      const [x0, y0, x1, y1] = CAT.panneaux[cote], W = x1 - x0, H = y1 - y0;
      return [(x0 + fx * W) * KG, (y0 + fy * H) * KG, fw * W * KG, fh * H * KG];
    }
    function masqueTeinte(img, couleur) {
      const c = document.createElement('canvas'); c.width = img.width; c.height = img.height; const x = c.getContext('2d');
      x.drawImage(img, 0, 0); x.globalCompositeOperation = 'source-in'; x.fillStyle = rgb(couleur); x.fillRect(0, 0, c.width, c.height); return c;
    }
    function posDans(e, entree, slot) {                     // logo de poitrine posé de l'autre côté : même taille, centré sur l'emplacement choisi
      if (!entree.slot_origine || entree.slot_origine === slot || !CAT.centres_poitrine[slot]) return entree.pos;
      const c = CAT.centres_poitrine[slot], cible = c.modeles[modele(e)] || c.moyenne, [, , fw, fh] = entree.pos;
      return [cible[0] - fw / 2, cible[1] - fh / 2, fw, fh];
    }
    async function poserLogo(e, entree, cote, m, slot) {
      const [x, y, w, h] = boite(cote, slot ? posDans(e, entree, slot) : entree.pos);
      if (entree.teinte) {
        const img = await charger(entree.teinte);
        if (m.cerne) {                                        // contour : masque couleur du contour décalé tout autour
          const cc = masqueTeinte(img, m.couleur_cerne), r = m.cerne / K_EXPORT * KG;
          for (let a = 0; a < 16; a++) gx.drawImage(cc, x + Math.cos(a * Math.PI / 8) * r, y + Math.sin(a * Math.PI / 8) * r, w, h);
        }
        gx.drawImage(masqueTeinte(img, m.couleur_logos), x, y, w, h);
      }
      if (entree.fixe) gx.drawImage(await charger(entree.fixe), x, y, w, h);
    }
    // polices aux chiffres décalés (Blue Block : le glyphe « 0 » dessine un 1…) : on envoie le chiffre qui dessine celui voulu, comme l'impression
    const decaler = (txt, fichier) => { const d = (Object.values(CAT.polices || {}).find(p => p.fichier === fichier) || {}).decalage || 0;
      return d ? txt.replace(/\d/g, c => String((+c + d + 10) % 10)) : txt; };
    async function poserTexte(e, txt, t, m, choix, hauteur, ratio) {
      if (!txt || !t) return;
      if (t.glyphes && (!choix || choix === 'glyphes')) { const n = parseInt(txt, 10); if (t.pos[n]) await poserLogo(e, { pos: t.pos[n], teinte: t.glyphes.replace('{n}', n) }, 'dos', m); return; }
      const [x0, y0, x1, y1] = CAT.panneaux.dos, W = x1 - x0, H = y1 - y0;
      const autre = choix && choix !== 'glyphes' && CAT.polices[choix];
      const fichier = autre ? CAT.polices[choix].fichier : t.police, fam = await police(fichier); txt = decaler(txt, fichier);
      let taille = autre ? hauteur * H * KG / CAT.polices[choix][ratio] : t.taille * H * KG;
      gx.font = `${taille}px "${fam}"`; const maxi = t.largeur_max * W * KG; const l = gx.measureText(txt).width;
      if (l > maxi) { taille *= maxi / l; gx.font = `${taille}px "${fam}"`; }
      gx.textAlign = 'center'; gx.textBaseline = 'alphabetic';
      const x = (x0 + t.axe_x * W) * KG, y = (y0 + t.base_y * H) * KG;
      if (m.cerne) { gx.lineJoin = 'round'; gx.lineWidth = m.cerne / K_EXPORT * KG * 2; gx.strokeStyle = rgb(m.couleur_cerne); gx.strokeText(txt, x, y); }
      gx.fillStyle = rgb(m.couleur_logos); gx.fillText(txt, x, y);
    }
    async function composer(e) {
      const m = style(e), c = CAT.coloris[e.coloris];
      gx.globalCompositeOperation = 'source-over'; gx.drawImage(await charger(e.gabarit === 'produit' && c.gabarit_produit ? c.gabarit_produit : c.gabarit), 0, 0, GW, GH);
      for (const s of SLOTS) if (e[s] && LOGO[e[s]]) await poserLogo(e, LOGO[e[s]], COTE[s], m, s);
      const tx = CAT.textes[modele(e)] || {}, nom = e.nom || '', numero = e.numero ?? '';
      const pn = e.police_nom && e.police_nom !== tx.police_nom ? e.police_nom : null;
      await poserTexte(e, m.minuscules && !pn ? nom.toLowerCase() : nom.toUpperCase(), m.nom, m, pn, tx.h_nom, 'cap');
      const pu = e.police_num && e.police_num !== tx.police_num ? e.police_num : null;
      if (numero !== '') await poserTexte(e, String(numero), m.numero || m.nom, m, pu || (m.numero ? null : tx.police_nom), tx.h_num || tx.h_nom * 2.4, 'chif');
    }

    /* ---------- 2. photo recalculée (WebGL2) ---------- */
    const GLC = document.createElement('canvas'); GLC.width = GLC.height = TAILLE;
    const gl = GLC.getContext('webgl2', { alpha: false, antialias: false, depth: false, preserveDrawingBuffer: true });
    let progRendu, progAbar, texLUT, texGab, fbAbar; const cartes = {};
    const VS = `#version 300 es
out vec2 vTex;
void main() { vec2 p = vec2((gl_VertexID << 1) & 2, gl_VertexID & 2); vTex = vec2(p.x, 1.0 - p.y); gl_Position = vec4(p * 2.0 - 1.0, 0.0, 1.0); }`;
    const FS_RENDU = `#version 300 es
precision highp float; precision highp sampler3D;
uniform sampler2D uUV, uUVv, uB, uA1, uA2, uGabarit; uniform sampler3D uLUT;
uniform vec3 uMaxB, uMinA1, uMaxA1, uMinA2, uMaxA2, uF, uAbar;
in vec2 vTex; out vec4 outColor;
vec3 decodeG(vec3 q, vec3 lo, vec3 hi) { return lo + pow(q, vec3(2.2)) * (hi - lo); }
void main() {
  vec3 eu = floor(texture(uUV, vTex).rgb * 255.0 + 0.5), ev = floor(texture(uUVv, vTex).rgb * 255.0 + 0.5);
  vec2 uv = vec2(eu.r * 256.0 + eu.g, ev.r * 256.0 + ev.g) / 65535.0;
  vec3 a = eu.b > 127.0 ? textureLod(uGabarit, vec2(uv.x, 1.0 - uv.y), 0.0).rgb : vec3(0.0);
  float B = dot(decodeG(texture(uB, vTex).rgb, vec3(0.0), uMaxB), uF);
  float A1 = dot(decodeG(texture(uA1, vTex).rgb, uMinA1, uMaxA1), uF);
  float A2 = dot(uMinA2 + texture(uA2, vTex).rgb * (uMaxA2 - uMinA2), uF);
  vec3 x = vec3(B) + a * (A1 + uAbar * A2);
  vec3 t = clamp((log2(max(x, vec3(1e-12))) + 14.0) / 22.0, 0.0, 1.0);
  outColor = vec4(texture(uLUT, t * (64.0 / 65.0) + 0.5 / 65.0).rgb, 1.0);
}`;
    const FS_ABAR = `#version 300 es
precision highp float;
uniform sampler2D uUV, uUVv, uGabarit; uniform int uPas; out vec4 outColor;
void main() {
  ivec2 px = ivec2(gl_FragCoord.xy) * uPas + uPas / 2;
  vec3 eu = floor(texelFetch(uUV, px, 0).rgb * 255.0 + 0.5), ev = floor(texelFetch(uUVv, px, 0).rgb * 255.0 + 0.5);
  if (eu.b < 128.0) { outColor = vec4(0.0); return; }
  vec2 uv = vec2(eu.r * 256.0 + eu.g, ev.r * 256.0 + ev.g) / 65535.0;
  outColor = vec4(sqrt(textureLod(uGabarit, vec2(uv.x, 1.0 - uv.y), 0.0).rgb), 1.0);
}`;
    function programme(fs) {
      const p = gl.createProgram();
      for (const [type, src] of [[gl.VERTEX_SHADER, VS], [gl.FRAGMENT_SHADER, fs]]) {
        const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
        if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error('shader : ' + gl.getShaderInfoLog(s));
        gl.attachShader(p, s);
      }
      gl.linkProgram(p); if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error('programme : ' + gl.getProgramInfoLog(p)); return p;
    }
    async function donnees(chemin) {                       // cartes = DONNÉES : on demande le PNG d'origine (sinon le CDN Shopify le recompresse en WebP)
      const r = await fetch(url(chemin), { headers: { Accept: 'image/png' } });
      return createImageBitmap(await r.blob(), { colorSpaceConversion: 'none', premultiplyAlpha: 'none' });
    }
    function texture(src, interne, format, filtre) {
      const t = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texImage2D(gl.TEXTURE_2D, 0, interne, format, gl.UNSIGNED_BYTE, src);
      for (const [k, v] of [[gl.TEXTURE_MIN_FILTER, filtre], [gl.TEXTURE_MAG_FILTER, filtre], [gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE], [gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE]]) gl.texParameteri(gl.TEXTURE_2D, k, v);
      return t;
    }
    async function initGL() {
      if (!gl) throw new Error('webgl2');
      gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE); gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false); gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
      progRendu = programme(FS_RENDU); progAbar = programme(FS_ABAR);
      P = await (await fetch(url('cartes/parametres.json'))).json();
      const bl = await donnees('cartes/table-couleur-65-web.png'), n = bl.height;      // table couleur → texture 3D 65³
      const tl = texture(bl, gl.RGBA8, gl.RGBA, gl.NEAREST), fb = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, fb); gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, tl, 0);
      const px = new Uint8Array(bl.width * n * 4); gl.readPixels(0, 0, bl.width, n, gl.RGBA, gl.UNSIGNED_BYTE, px);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null); gl.deleteFramebuffer(fb); gl.deleteTexture(tl);
      const d = new Uint8Array(n * n * n * 3);
      for (let b = 0; b < n; b++) for (let g = 0; g < n; g++) for (let r = 0; r < n; r++) {
        const s = (g * bl.width + r + n * b) * 4, o = ((b * n + g) * n + r) * 3; d[o] = px[s]; d[o + 1] = px[s + 1]; d[o + 2] = px[s + 2];
      }
      texLUT = gl.createTexture(); gl.bindTexture(gl.TEXTURE_3D, texLUT);
      gl.texImage3D(gl.TEXTURE_3D, 0, gl.RGB8, n, n, n, 0, gl.RGB, gl.UNSIGNED_BYTE, d);
      for (const k of [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T, gl.TEXTURE_WRAP_R]) gl.texParameteri(gl.TEXTURE_3D, k, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_3D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_3D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      for (const v of FACES) {                                // pages produit : seulement le dos (5 cartes au lieu de 10)
        const [u, vv, B, A1, A2] = await Promise.all(['uv-u', 'uv-v', 'reflets-et-fond', 'lumiere', 'lumiere-rebond'].map(nm => donnees(`cartes/${TAILLE}/${v}-${nm}.png`)));
        cartes[v] = { u: texture(u, gl.RGB8, gl.RGB, gl.NEAREST), v: texture(vv, gl.RGB8, gl.RGB, gl.NEAREST),
          B: texture(B, gl.RGB8, gl.RGB, gl.LINEAR), A1: texture(A1, gl.RGB8, gl.RGB, gl.LINEAR), A2: texture(A2, gl.RGB8, gl.RGB, gl.LINEAR) };
      }
      const ta = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, ta); gl.texStorage2D(gl.TEXTURE_2D, 1, gl.RGBA8, 256, 256);
      fbAbar = gl.createFramebuffer(); gl.bindFramebuffer(gl.FRAMEBUFFER, fbAbar); gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, ta, 0);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    }
    const SRGB2LIN = new Float64Array(256).map((_, i) => { const c = i / 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); });
    function interp(x, pts) {
      const xs = pts.map(p => Math.log10(p[0])), ys = pts.map(p => p[1]);
      if (x <= xs[0]) return ys[0]; if (x >= xs[xs.length - 1]) return ys[ys.length - 1];
      let i = 0; while (x > xs[i + 1]) i++; return ys[i] + (ys[i + 1] - ys[i]) * (x - xs[i]) / (xs[i + 1] - xs[i]);
    }
    function eclairage() {                                  // règle automatique : clarté linéaire moyenne des zones devant + dos
      let s = 0, nb = 0;
      for (const [x0, y0, x1, y1] of [[447, 693, 3819, 5198], [4624, 715, 7996, 5199]]) {
        const ax = Math.floor(x0 * KG), ay = Math.floor(y0 * KG), l = Math.floor(x1 * KG) - ax, h = Math.floor(y1 * KG) - ay;
        const px = gx.getImageData(ax, ay, l, h).data;
        for (let i = 0; i < px.length; i += 16) { s += 0.2126 * SRGB2LIN[px[i]] + 0.7152 * SRGB2LIN[px[i + 1]] + 0.0722 * SRGB2LIN[px[i + 2]]; nb++; }
      }
      const lg = Math.log10(Math.max(s / nb, 1e-4)), R = P.regle_eclairage_auto; return [interp(lg, R.key), interp(lg, R.rim)];
    }
    function lier(prog, unite, nom, t, cible) { gl.activeTexture(gl.TEXTURE0 + unite); gl.bindTexture(cible || gl.TEXTURE_2D, t); gl.uniform1i(gl.getUniformLocation(prog, nom), unite); }
    function albedoMoyen(c) {
      gl.useProgram(progAbar); lier(progAbar, 0, 'uUV', c.u); lier(progAbar, 1, 'uUVv', c.v); lier(progAbar, 2, 'uGabarit', texGab);
      gl.uniform1i(gl.getUniformLocation(progAbar, 'uPas'), TAILLE / 256);
      gl.bindFramebuffer(gl.FRAMEBUFFER, fbAbar); gl.viewport(0, 0, 256, 256); gl.drawArrays(gl.TRIANGLES, 0, 3);
      const px = new Uint8Array(256 * 256 * 4); gl.readPixels(0, 0, 256, 256, gl.RGBA, gl.UNSIGNED_BYTE, px); gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      const s = [0, 0, 0]; let nb = 0;
      for (let i = 0; i < px.length; i += 4) if (px[i + 3] === 255) { for (let k = 0; k < 3; k++) s[k] += (px[i + k] / 255) ** 2; nb++; }
      return s.map(x => x / Math.max(nb, 1));
    }
    function photo(c, f, abar) {
      const p = progRendu; gl.useProgram(p);
      lier(p, 0, 'uUV', c.u); lier(p, 1, 'uUVv', c.v); lier(p, 2, 'uB', c.B); lier(p, 3, 'uA1', c.A1); lier(p, 4, 'uA2', c.A2); lier(p, 5, 'uGabarit', texGab); lier(p, 6, 'uLUT', texLUT, gl.TEXTURE_3D);
      const u3 = (nom, a) => gl.uniform3fv(gl.getUniformLocation(p, nom), a);
      u3('uMaxB', P.max_B); u3('uMinA1', P.min_A1); u3('uMaxA1', P.max_A1); u3('uMinA2', P.min_A2); u3('uMaxA2', P.max_A2); u3('uF', [f[0], f[1], 1]); u3('uAbar', abar);
      gl.viewport(0, 0, TAILLE, TAILLE); gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    let jeton = 0, pret = null, fond = null;
    const demarrer = () => pret || (pret = charge.then(initGL));   // WebGL et cartes chargés au premier rendu seulement
    async function rendre(e, sorties) {                     // sorties = { devant: [canvas…], dos: [canvas…] } ; renvoie false si un rendu plus récent l'a remplacé
      const mon = ++jeton; await demarrer(); await composer(e);
      if (mon !== jeton) return false;
      if (texGab) gl.deleteTexture(texGab);
      texGab = texture(G, gl.SRGB8_ALPHA8, gl.RGBA, gl.LINEAR);  // le GPU repasse en linéaire avant de filtrer
      const f = eclairage();
      for (const v of FACES) {
        if (!sorties[v] || !sorties[v].length) continue;
        photo(cartes[v], f, albedoMoyen(cartes[v]));
        for (const cv of sorties[v]) if (cv) cv.getContext('2d').drawImage(GLC, 0, 0, TAILLE, TAILLE, 0, 0, cv.width, cv.height);
        if (!fond) { const p = new Uint8Array(4); gl.readPixels(2, TAILLE - 3, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, p); fond = `rgb(${p[0]},${p[1]},${p[2]})`; }
      }
      return true;
    }
    return { charge, demarrer, rendre, url, charger, police, decaler, style, masqueTeinte, rgb, modele, TAILLE, SLOTS, COTE,
      cat: () => CAT, logos: () => LOGO, fondPhoto: () => fond };
  };
})();
